module.exports = __webpack_public_path__ + "img/neon-unlooped.5fc0f5c3.png";